/**
 * Shared recharts tooltip value formatter for the energy panels, so all three
 * charts render clean, rounded numbers with a unit instead of raw floats.
 *
 * - Watt-style units (e.g. " W") round to whole numbers — sub-watt precision is
 *   noise on a live power reading.
 * - Everything else (e.g. " kWh") rounds to at most 2 decimals, trimming
 *   trailing zeros so 1.50 -> "1.5" and 2.00 -> "2".
 * Non-numeric values are stringified untouched.
 */
export function formatChartValue(value: unknown, unit = ""): string {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return `${String(value)}${unit}`;
  }
  const isWatts = unit.trim().toLowerCase() === "w";
  const rounded = isWatts ? Math.round(value) : Number(value.toFixed(2));
  return `${rounded}${unit}`;
}
